export default class FreeSpins {
  constructor(view) {
    this.freeSpins = 0;
    this.view = view;

    this.view.set({ visible: false });
    this.view.freeSpinsWin.set({ y: -50 });
    this.view.freeSpinsAmount.set({ y: -50 });
    this.view.freeSpinsWindow.set({ scaleX: 0, scaleY: 0 });
    this.view.freeSpinsMulti.set({ scaleX: 0, scaleY: 0 });
  }

  updateBeforePlay(freeSpins, freeSpinsDone) {
    if (!freeSpinsDone && this.freeSpins) {
      this.endFreeSpins();
    }
    this.updateAmount(freeSpins, freeSpinsDone);
  }

  updateAfterPlay(freeSpins, freeSpinsDone, win) {
    this.view.freeSpinsWin.win.text = `${win} G`;

    if (freeSpins > this.freeSpins) {
      return new Promise(resolve => setTimeout(resolve, 800))
        .then(() => this.setFreeSpinsWindowText('win', freeSpins - this.freeSpins))
        .then(() => this.startFreeSpins(freeSpins, freeSpinsDone));
    }
    this.updateAmount(freeSpins, freeSpinsDone);

    return Promise.resolve();
  }

  showFreeSpinsLeft(freeSpins, freeSpinsDone) {
    this.view.freeSpinsWin.win.text = '';
    this.updateAmount(freeSpins, freeSpinsDone);
    this.setFreeSpinsWindowText('left', freeSpins - freeSpinsDone);
    return this.startFreeSpins(freeSpins, freeSpinsDone);
  }

  updateAmount(freeSpins, freeSpinsDone) {
    const spins = this.freeSpins || freeSpins;
    this.view.freeSpinsAmount.amount.text = spins - freeSpinsDone;
  }

  endFreeSpins() {
    this.freeSpins = 0;

    [this.view.freeSpinsAmount, this.view.freeSpinsWin].forEach(item =>
      createjs.Tween.get(item).to({ y: -50 }, 500));

    createjs.Tween.get(this.view.freeSpinsMulti)
      .to({ scaleX: 0, scaleY: 0 }, 500)
      .call(() => this.view.set({ visible: false }));
  }

  startFreeSpins(freeSpins, freeSpinsDone) {
    this.freeSpins = freeSpins;
    this.view.visible = true;

    [this.view.freeSpinsAmount, this.view.freeSpinsWin].forEach(item =>
      createjs.Tween.get(item)
        .to({ y: 120 }, 300)
        .to({ y: 80 }, 200));

    createjs.Tween.get(this.view.freeSpinsMulti)
      .to({ scaleX: 1.3, scaleY: 1.3 }, 300)
      .to({ scaleX: 1, scaleY: 1 }, 200);

    return new Promise(resolve =>
      createjs.Tween.get(this.view.freeSpinsWindow)
        .to({ scaleX: 1, scaleY: 1 }, 350)
        .call(() => this.updateAmount(freeSpins, freeSpinsDone))
        .to({ scaleX: 1.3, scaleY: 1.3 }, 250)
        .to({ scaleX: 1, scaleY: 1 }, 200)
        .wait(1000)
        .to({ scaleX: 0, scaleY: 0 }, 300)
        .call(resolve));
  }

  setFreeSpinsWindowText(msg, value) {
    const messages = {
      win: `Вы выиграли\n${value} бесплатных розыгрышей`,
      left: `У вас осталось\n${value} бесплатных розыгрышей`,
    };

    this.view.freeSpinsWindow.txt.text = messages[msg];
  }
}



// WEBPACK FOOTER //
// ../base/js/display/FreeSpins.js